import { gql } from "@apollo/client";

export default gql`
    query coupons(
        $limit: Int = 20
        $offset: Int = 0
        $where: subscription_coupon_bool_exp
        $order_by: [subscription_coupon_order_by!] = { created_at: desc }
    ) {
        coupons: subscription_coupon(
            limit: $limit
            offset: $offset
            where: $where
            order_by: $order_by
        ) {
            id
            code
            type
            value
            valid_from
            valid_till
            user_type
            regions
            plans
            is_active
            created_at
        }
    }
`;
